import { Injectable } from '@angular/core';
import { ParentModel } from '../shared/study/model/parent.model';
import { PreviewCrossesModel } from '../shared/study/model/preview-crosses.model';
import { CrossSourceEntryModel } from '../shared/study/model/cross-source-entry.model';

@Injectable()
export class DesignCrossesContext {
    studyId: number;
    studyName: string;
    activeGermplasmListId: number;
    activeListName: string;
    selectedFemaleParents: ParentModel[] = [];
    selectedMaleParents: ParentModel[] = [];
    crosses: PreviewCrossesModel[] = [];
    cross: PreviewCrossesModel;
    draggedItems: CrossSourceEntryModel[];
    crossType: string;
    openedDirectlyFromNewStudyEditor: boolean;

}
